<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <h1 class="mb-4">Documents</h1>
          <div v-if="trainings">
            <div v-for="(training, index) in trainings" :key="index" class="">
              <h2>{{ training.topic }}</h2>
              <p>{{ training.description }}</p>
              <iframe
                :src="training.link"
                class="trainings-iframe centered-content-iframe"
              />
            </div>
          </div>
          <div v-else>No tutorials at the moment</div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  name: "TrainingDocuments",
  computed: {
    ...mapGetters({
      trainings: "releases/trainings"
    })
  },

  created() {
    this.$store.dispatch("releases/getTrainings")
  }
}
</script>
